const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins
const { debounce, viewportSize } = window.BAO.Utils

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide?.exists) return
    if (this.els.slide?.elements.length < 2) return

    this.carousel = this.setupCarousel()

    this.currentIndex = 0

    this.updateSlideAttributes()
  }

  setupListeners () {
    super.setupListeners()

    this.debouncedHandleResize = debounce((e) => this.handleResize(e), 500)
    window.addEventListener('resize', this.debouncedHandleResize, {
      passive: true,
    })
  }

  setupCarousel () {
    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )

    slider.on('slideChanged', (e) => {
      this.currentIndex = e.track.details.abs
      this.updateSlideAttributes()
    })

    return slider
  }

  handleResize () {
    this.updateSlideAttributes()
  }

  updateSlideAttributes () {
    const currentViewportSize = viewportSize()

    this.els.slide?.elements?.forEach((slide, index) => {
      const link = slide.querySelector(this.els.link.selector)

      if (currentViewportSize === 'xs' || currentViewportSize === 'sm') {
        if (link) {
          link.setAttribute(
            'tabindex',
            index === this.currentIndex ? '0' : '-1',
          )
        }
      } else {
        if (link) link.removeAttribute('tabindex')
      }
    })
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
